﻿export class WorkItemNotFound {
}